export default "__VITE_ASSET__t$uGTsGx__"